import { configure, makeAutoObservable } from 'mobx';

import { NotificationsStore } from '../NotificationsStore';
import { ParametersList } from 'types/trackmanParameters';
import TrackmanParametersService from '../../services/TrackmanParameters/TrackmanParameters';
import { getErrorMessage } from 'utilities/ErrorHelper';
import { sortParametersDataWithFixedOrder } from 'utilities/sortTrackmanParameters';

configure({ enforceActions: 'never' });

const desiredPrimaryCategoriesOrder = ['Tee-to-green', 'Putting', 'Biomechanics'];
const desiredTeeToGreenSubcategoriesOrder = ['Club', 'Launch', 'Flight'];
const desiredPuttingSubcategoriesOrder = ['Club', 'Launch', 'Roll', 'Green'];
const desiredBiomechanicsSubcategoriesOrder = ['Alignment', 'Rotations', 'Translations'];

export class TrackmanParametersStore {
  private trackmanParametersService: TrackmanParametersService;
  private ns: NotificationsStore;

  constructor(trackmanParametersService: TrackmanParametersService, notificationStore: NotificationsStore) {
    makeAutoObservable(this); //This line will automatically decorate each store property with 'observable' and each method with 'action'.
    this.trackmanParametersService = trackmanParametersService;
    this.ns = notificationStore;
  }

  parametersList: ParametersList | Record<string, never> = {};
  isParametersLoading: boolean = true;

  getTrackmanParameters = async () => {
    try {
      this.isParametersLoading = true;
        const response = await this.trackmanParametersService.getTrackmanParameters();

      if (Object.keys(response).length === 0) {
        this.parametersList = response;
      } else {
        const mainCategoriesSorted: ParametersList = sortParametersDataWithFixedOrder(response, desiredPrimaryCategoriesOrder);
        mainCategoriesSorted['Tee-to-green'] = sortParametersDataWithFixedOrder(
          mainCategoriesSorted['Tee-to-green'],
          desiredTeeToGreenSubcategoriesOrder
        );
        mainCategoriesSorted['Putting'] = sortParametersDataWithFixedOrder(
          mainCategoriesSorted['Putting'],
          desiredPuttingSubcategoriesOrder
          );

        if (mainCategoriesSorted['Biomechanics'] != undefined) {
            mainCategoriesSorted['Biomechanics'] = sortParametersDataWithFixedOrder(
                mainCategoriesSorted['Biomechanics'],
                desiredBiomechanicsSubcategoriesOrder
            );
        }

        this.parametersList = mainCategoriesSorted;
      }
    } catch (ex) {
      this.ns.addToast('error', getErrorMessage(ex), 'error');
    }
    this.isParametersLoading = false;
  };
}

export default TrackmanParametersStore;
